import React from 'react';
import './Home.css';
import partsklikLogo from '../../Assets/partsklik-logo.png';
import turbowaleFrame from '../../Assets/Frame 17.png';
import germanPurjeImage from '../../Assets/germanpurje-bg.jpg'; // make sure this exists in the correct path
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <>
            <div className="home-page">
                <div className="main-container">
                    {/* Partsklik Logo and Welcome Message at the Top */}
                    <div className="top-container">
                        <img src={partsklikLogo} alt="Partsklik Logo" className="partsklik-logo" />
                        <h1 className="welcome-message">Welcome to Partsklik LLP</h1>
                    </div>

                    <div className="new-content">
                        <div className="box-card">
                            <img src={turbowaleFrame} alt="TURBOCHARGER" />
                            <div className="info">
                                <a href="https://turbowale.com" target="_blank" rel="noopener noreferrer" className="website-button">
                                    Visit Turbowale <i className="fa-solid fa-link"></i>
                                </a>
                                <p>If you're looking for turbochargers, turbo kits, turbo core and related components.</p>
                            </div>
                        </div>

                        <div className="box-card">
                            <div className="info">
                                <img src={germanPurjeImage} alt="SPARE PARTS" />
                                <a href="https://germanpurje.com" target="_blank" rel="noopener noreferrer" className="website-button">
                                    Visit German Purje <i className="fa-solid fa-link"></i>
                                </a>
                                <p>For all your luxury car parts, including accessories and more.</p>
                            </div>
                        </div>
                    </div>



                    {/* Footer strip */}
                    <div className="home-footer">
                        <p className='my-0 p-0' >© {new Date().getFullYear()} Partsklik LLP. All rights reserved.</p>
                        <Link to="/terms-and-conditions" className="tnc-link">
                            Terms &amp; Conditions
                        </Link>
                    </div>


                </div>

            </div>
        </>
    );
};

export default Home;
